var freeshippingColor = "https://shopfront-cdn.tekoapis.com/static/0e5c8af0b6cd0275.svg";

export { freeshippingColor as default };
